import { createResource } from "~/lib/resourceFactory";
import { getBusinessDetail, listBusinesses } from "./business.api";

type BusinessesCollection = Awaited<ReturnType<typeof listBusinesses>>;
type BusinessDetail = Awaited<ReturnType<typeof getBusinessDetail>>;

// Resource definitions expose stable query keys and cache helpers for the route.
export const businessesResource = createResource<
	BusinessesCollection,
	undefined
>({
	key: () => ["businesses"] as const,
	fetcher: () => listBusinesses(),
});

export const businessDetailResource = createResource<BusinessDetail, string>({
	key: (id: string) => ["business", id] as const,
	fetcher: (id: string) => getBusinessDetail({ data: { businessId: id } }),
});

/**
 * Returns a reactive accessor for the currently active business ID.
 * Use this in route components instead of duplicating the businessesResource.use() pattern.
 */
export function useActiveBusinessId() {
	const collection = businessesResource.use(() => undefined);
	return () => collection.data?.activeBusinessId ?? null;
}
